// extracted by mini-css-extract-plugin
export default {"root":"hFWROj","slideItem":"faYbch","slideItemSingle":"WgWrAr","slideImage":"Crgr1K","dots":"wOj1fb","arrowRight":"tdS2pN","icon":"tLeVko","arrowLeft":"qRpkmj","slideLink":"WptfqY"};